import JSZip from "jszip";
import { saveAs } from "file-saver";
import { fileTypeFromBlob } from 'file-type';

import { downloadFileAsBlob } from '../api/requests';

export const downloadAll = (title, items, onFinish) => {
  const zip = new JSZip();
  let promises = [];

  for (let item of items) {
    const itemPromise = new Promise((resolve) => {
      downloadFileAsBlob(item.id, true)
      .then((response) => {
          fileTypeFromBlob(response.data).then((type) => {
            zip.file(`${item.name}.${type.ext}`, response.data);
            resolve();
          });
        })
        .catch(() => resolve())
    });

    promises.push(itemPromise);
  }

  return new Promise((resolve) => {
    Promise.all(promises).then(() => {
      zip.generateAsync({ type: "blob" }).then((blob) => {
        saveAs(blob, `${title.replace(/ /g, "_")}.zip`);
        setTimeout(() => resolve(), 500);
        if (onFinish) {
          onFinish();
        }
      });
    });
  });
};
